import { text, toDate } from "@/lib/format";

const last10 = (p) => String(p || "").replace(/\D/g, "").slice(-10);
const empty = (v) => v == null || v === "" || (Array.isArray(v) && !v.length);
const mergeInto = (a, b) => { Object.entries(b).forEach(([k, v]) => { if (empty(a[k]) && !empty(v)) a[k] = v; }); return a; };

// One row per real person: merge users docs by auth uid, then by phone; enrich from requests, addresses and Firebase Auth.
export function buildCustomers({ users, requests, addresses, customersColl, authUsers }) {
  const authByUid = Object.fromEntries((authUsers || []).map((a) => [a.uid, a]));
  const groups = new Map();
  users.filter((u) => (u.role || "customer") === "customer").forEach((u) => {
    const key = u.auth_uid || u.uid || u.user_id || u.id;
    const g = groups.get(key) || { key, docIds: [], data: {} };
    g.docIds.push(u.id);
    if (u.id === key) g.data = mergeInto({ ...u }, g.data); else mergeInto(g.data, u);
    groups.set(key, g);
  });
  // second pass: same phone => same person
  const byPhone = new Map();
  const out = [];
  groups.forEach((g) => {
    const ph = last10(g.data.phone || authByUid[g.key]?.phone);
    const hit = ph.length === 10 ? byPhone.get(ph) : null;
    if (hit) { hit.docIds.push(...g.docIds); hit.altUids.push(g.key); mergeInto(hit.data, g.data); return; }
    const row = { ...g, altUids: [] };
    if (ph.length === 10) byPhone.set(ph, row);
    out.push(row);
  });
  const reqBy = {};
  requests.forEach((r) => { (reqBy[r.customer_id] ||= []).push(r); });
  return out.map((g) => {
    const uids = [g.key, ...g.altUids, ...g.docIds];
    const reqs = Array.from(new Set(uids.flatMap((u) => reqBy[u] || [])));
    const auth = authByUid[g.key] || {};
    const cust = customersColl.find((c) => uids.includes(c.id) || uids.includes(c.user_id)) || {};
    const addrs = addresses.filter((a) => uids.includes(a.customer_id) || uids.includes(a.user_id));
    const fromReq = reqs.map((r) => r.service_address?.contact || {}).find((c) => c.name || c.phone) || {};
    const d = g.data;
    const primaryId = g.docIds.includes(g.key) ? g.key : g.docIds[0];
    return {
      id: primaryId, uid: g.key, uids, docIds: Array.from(new Set(g.docIds)), raw: d, auth, cust, addrs, reqs,
      name: text(d.name || d.full_name || d.display_name || cust.name || auth.display_name || reqs.find((r) => r.customer_name)?.customer_name || fromReq.name, null),
      phone: text(d.phone || auth.phone || cust.phone || reqs.find((r) => r.customer_phone)?.customer_phone || fromReq.phone, null),
      email: text(d.email || auth.email || cust.email, null),
      city: text(d.city || cust.city || addrs[0]?.city || reqs.find((r) => r.city)?.city, null),
      address: text(d.current_address?.formatted || d.current_address?.address || addrs[0]?.formatted_address || addrs[0]?.address, null),
      created_at: d.created_at || (auth.created_at ? new Date(auth.created_at).toISOString() : null),
      last_login_at: d.last_login_at || (auth.last_sign_in_at ? new Date(auth.last_sign_in_at).toISOString() : null),
      auth_disabled: auth.disabled === true,
    };
  }).sort((a, b) => (toDate(b.created_at)?.getTime() || 0) - (toDate(a.created_at)?.getTime() || 0));
}
